import { Form, Input, Row, Col, Switch, Select, DatePicker, InputNumber } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const EditComponent = (props: any) => {
    const [form] = Form.useForm();
    const apiId = 'membershipCarePlans';
    const { editMode, defaultService } = props;
    const ref = useRef<any>(undefined);
    const [membershipTypeData, setMembershipTypeData] = useState<any>();
    const [membershipCarePlansModelData, setMembershipCarePlansModelData] = useState<any>();
    const [smsServiceData, setSmsServiceData] = useState<any>();
    const [permanentUseDisabled, setPermanentUseDisabled] = useState<boolean>(false);

    const [smsServiceIdDisabled, setSmsServiceIdDisabled] = useState<boolean>(false);

    const setMembershipCarePlansModel = (e: string) => {
        switch (e) {
            case 'sendSmsOnBirthday':
                setSmsServiceIdDisabled(false);
                break;
            //other
            default:
                setSmsServiceIdDisabled(true);
                break;
        }
    }

    useEffect(() => {
        if (ref.current) {
            ref.current.getRow?.then((res: any) => {
                if (res?.success === true) {
                    setPermanentUseDisabled(res.data.isPermanentUse);
                    setMembershipCarePlansModel(res.data.membershipCarePlansModelId);
                }
            })
        }
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'membershipCarePlansModel',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { membershipCarePlansModel } = res.data;
                    setMembershipCarePlansModelData(membershipCarePlansModel);;
                }
            });
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'membershipType',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipTypeData(res.data);
                }
            });
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'smsService',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setSmsServiceData(res.data);
                }
            });

    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId: 'membershipCarePlans',
        serviceId: 'business',
        displayOptions: {
            width: 1000
        },
        dateOptions: {
            columnNames: ['startDate', 'endDate']
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={4}>
                        <Form.Item
                            label="ID"
                            name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="方案"
                            name="planName"
                            rules={[{ required: true, message: '方案名称!' }]}>
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="模式"
                            name="membershipCarePlansModelId"
                            tooltip='会员关怀方案模式'
                            rules={[{ required: true, message: '请选择会员关怀方案模式!' }]}>
                            <Select
                                showSearch
                                placeholder="模式"
                                optionFilterProp="children"
                                onSelect={(e) => {
                                    setMembershipCarePlansModel(e);
                                }}
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(membershipCarePlansModelData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="类别"
                            name="membershipTypeId"
                            tooltip='会员类别'
                            rules={[{ required: true, message: '请选择类别!' }]}>
                            <Select
                                showSearch
                                placeholder="类别"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(membershipTypeData, { itemName: 'typeName' })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={7}>
                        <Form.Item
                            label="起始日期"
                            name="startDate"
                            tooltip='方案的起始日期'>
                            <DatePicker
                                disabled={permanentUseDisabled}
                                format="YYYY-MM-DD HH:mm:ss" />
                        </Form.Item>
                    </Col>

                    <Col span={7}>
                        <Form.Item
                            label="结束日期"
                            name="endDate"
                            tooltip='方案的结束日期'>
                            <DatePicker
                                disabled={permanentUseDisabled}
                                format="YYYY-MM-DD HH:mm:ss" />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="已用"
                            name="usedCopies"
                            tooltip='方案已用份数'>
                            <InputNumber
                                disabled={editMode === 'NEW' ? true : false}
                                style={{ width: 130 }} />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="总数"
                            name="totalCopies"
                            tooltip='方案的总份数' >
                            <InputNumber
                                disabled={permanentUseDisabled}
                                style={{ width: 130 }} />
                        </Form.Item>
                    </Col>

                    <Col span={10}>
                        <Form.Item
                            label="短信服务"
                            name="smsServiceId"
                            tooltip='短信服务'>
                            <Select
                                showSearch
                                placeholder="短信服务"
                                optionFilterProp="children"
                                disabled={smsServiceIdDisabled}
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(smsServiceData, { itemName: 'serviceName' })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="生日前几天"
                            name="daysBeforeBirthday"
                            tooltip='生日前几天发短信，默认：0，前一天：1，前二天：2，......' >
                            <InputNumber
                                disabled={smsServiceIdDisabled}
                                style={{ width: 80 }} />
                        </Form.Item>
                    </Col>

                    <Col span={3}>
                        <Form.Item
                            label="永久"
                            name="isPermanentUse"
                            tooltip='方案永久使用'
                            valuePropName="checked"
                            initialValue={false}>
                            < Switch
                                onChange={(e) => {
                                    setPermanentUseDisabled(e);
                                }}
                                checked={false}
                                checkedChildren="是"
                                unCheckedChildren="否" />
                        </Form.Item>
                    </Col>

                    <Col span={3}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="内容规则"
                            tooltip='短信内容规则，例如：亲爱的@typeName@membershipName会员，岁岁年年，美味相伴！今天是您的生日，祝您生日快乐！以上替换内容：
                                @typeName：会员类型；@membershipName：会员名；'
                            name="smsContentRules">
                            < Input.TextArea
                                disabled={smsServiceIdDisabled}
                                autoSize={{ minRows: 4, maxRows: 10 }}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="备注"
                            name="remarks">
                            < Input.TextArea autoSize={{ minRows: 1, maxRows: 10 }} />
                        </Form.Item>
                    </Col>

                </Row>)
        }
    };
    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;